import "./SingleProjectTemplate.module.css"
import Header from "@/reusable_sections/Header"
import Project from "./sections/Project"
import Footer from "@/reusable_sections/Footer"

export default function SingleProjectTemplatePage() {

  return (
    <div>
      <Header />
      <Project />
      <Footer />
    </div>
  )
}
